const scrapRoutes = {
  index: {
    path: 'index.maneuver.scrap',
    url: '/ferraillage',
  },
  selectWagons: {
    path: 'index.maneuver.scrap.wagon',
    url: '/selection-wagons',
  },
  createScrapping: {
    path: 'index.maneuver.scrap.createScrapping',
    url: '/saisie',
  },
  report: {
    path: 'index.maneuver.scrap.report',
    url: '/rapport',
  },
}

export default scrapRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/scrap/routes.js